var map = {
	"./BOKK.webp": 473,
	"./LogoSvg": 479,
	"./LogoSvg.tsx": 479,
	"./crudApp.webp": 743,
	"./konversiImg.webp": 80,
	"./logo-porto.webp": 866,
	"./portfolioImg.webp": 851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 958;